/**
 * importTramits reducer.
 * @module reducers/importTramits/importTramits
 */

import { IMPORT_TRAMITS } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
};

/**
 * importTramits reducer.
 * @function importTramits
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function importTramits(state = initialState, action = {}) {
  switch (action.type) {
    case `${IMPORT_TRAMITS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${IMPORT_TRAMITS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
      };
    case `${IMPORT_TRAMITS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
